import { motion } from "framer-motion";
import { Gift } from "lucide-react";

export const DealBanner = ({ onPreorder }) => (
  <section data-testid="deal-banner" className="relative bg-crimson overflow-hidden">
    <div
      className="absolute inset-0 opacity-10 pointer-events-none"
      style={{
        background:
          "repeating-linear-gradient(-45deg, #FFFFFF 0px, #FFFFFF 12px, transparent 12px, transparent 36px)",
      }}
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-20 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-jbmono text-xs uppercase tracking-[0.25em] text-gold mb-4 flex items-center gap-2">
          <Gift className="w-4 h-4" />
          Limited Pre-Order Deal
        </p>
        <h2 className="font-display font-black uppercase text-4xl sm:text-6xl leading-[0.95] tracking-tight text-white">
          Buy 3, Get 1 <span className="text-navy">FREE</span>
        </h2>
        <p className="mt-4 max-w-xl text-base sm:text-lg leading-relaxed text-white/85">
          The Freedom Pack: four Master Blasters for the price of three. One for every bathroom —
          or the greatest gag gift America has ever unwrapped.
        </p>
      </motion.div>
      <motion.button
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.15 }}
        onClick={() => onPreorder("both")}
        data-testid="deal-banner-claim-button"
        className="shrink-0 bg-white hover:bg-cream text-crimson font-display font-black uppercase tracking-wide text-xl px-10 py-5 rounded-sm transition-colors duration-200 shadow-[0_15px_40px_rgba(0,0,0,0.25)]"
      >
        Claim the Deal
      </motion.button>
    </div>
  </section>
);
